export const translationTestPortals_da = {
  pageTitle: "Test-portaler",
  pageSubtitle:
    "Opret delbare test-portaler, så kunder og interne testere kan afprøve chatbotten og give struktureret feedback - uden dashboard-login.",
  createPortal: "Opret test-portal",
  createFirstPortal: "Opret din første test-portal",
  editPortal: "Rediger test-portal",
  organizationPickerEyebrow: "Organisation",
  organizationPickerTitle: "Vælg en organisation",
  organizationPickerSubtitle:
    "Vælg den organisation, du vil administrere test-portaler for. Portaler er synlige og kan redigeres af brugere i samme organisation.",
  organizationSearchPlaceholder: "Søg efter organisationer, domæner eller chatbot IDs",
  organizationLoadError: "Kunne ikke hente organisationer.",
  organizationRequired: "Vælg en organisation først.",
  selectedOrganization: "Organisation: {name}",
  changeOrganization: "Skift organisation",
  organizationsShowing: "Viser {count} af {total} organisationer",
  previous: "Forrige",
  next: "Næste",
  pageOf: "Side {page} af {pages}",
  loadingOrganizations: "Indlæser organisationer...",
  noOrganizationsFound: "Ingen organisationer fundet.",
  adminAccess: "Admin-adgang",
  ownerAccess: "Ejeradgang",
  noDomainsConfigured: "Ingen domæner konfigureret",
  loading: "Indlæser...",
  loadError: "Kunne ikke hente test-portaler.",
  saveError: "Kunne ikke gemme test-portalen.",
  feedbackLoadError: "Kunne ikke hente tester-feedback.",
  emptyTitle: "Ingen test-portaler endnu",
  emptySubtitle:
    "Lav en test-portal, vælg de chatbots du vil teste, og del linket med dit team eller kunden.",
  active: "Aktiv",
  disabled: "Deaktiveret",
  enable: "Aktiver",
  disable: "Deaktiver",
  edit: "Rediger",
  delete: "Slet",
  cancel: "Annuller",
  save: "Gem",
  saving: "Gemmer...",
  chatbot: "chatbot",
  chatbots: "chatbots",
  copyLink: "Kopier link",
  copied: "Kopieret",
  copyManualPrompt: "Kopier dette link manuelt:",
  viewFeedback: "Se feedback",
  confirmDelete: 'Er du sikker på, at du vil slette "{name}"?',
  confirmDisable:
    'Deaktivering af "{name}" gør, at delingslinket stopper med at virke for testere. Fortsæt?',
  confirmDeleteFeedback: "Slet denne feedback?",
  confirmRotateToken:
    'Rotering af tokenet vil med det samme ugyldiggøre det eksisterende tester-delingslink for "{name}". Fortsæt?',
  rotateToken: "Roter link",
  openPortal: "Åbn portal",
  shareLink: "Delingslink",
  includedChatbots: "Inkluderede chatbots",
  backToList: "Tilbage til oversigt",
  created: "Oprettet",
  testerFeedback: "Tester-feedback",
  test_feedback: "test-feedback",
  feedbackReportsDescription:
    "Tester-feedback gemmes nu som almindelige samtalerapporter med rapporttypen {type}. Brug de eksisterende filtre, kommentarer, statusændringer og eksportflows i Samtaler.",
  openFeedbackReports: "Åbn test-feedback rapporter",
  filterAllStatuses: "Alle statusser",
  noFeedbackYet: "Ingen feedback modtaget endnu.",
  statTotalFeedback: "Total feedback",
  statOpen: "Åbne",
  statHighSeverity: "Høj prioritet",
  statBugs: "Bugs",
  expectedAnswer: "Forventet svar",
  testerInternal: "Intern tester",
  testerExternal: "Ekstern tester",
  fieldName: "Navn",
  namePlaceholder: "f.eks. Intern test af kundeservice",
  fieldDescription: "Beskrivelse",
  descriptionPlaceholder: "Forklar testerne hvad portalen handler om...",
  fieldWelcomeMessage: "Velkomstbesked",
  welcomePlaceholder: "Velkommen! Test gerne chatbotten og giv feedback.",
  fieldChatbots: "Chatbots",
  chatbotsHint: "Testerne kan skifte mellem de valgte chatbots i portalen.",
  noChatbotsAvailable: "Ingen chatbots tilgængelige i dit scope.",
  requireTesterIdentity: "Kræv navn/email fra testere ved feedback",
  fieldActive: "Portal er aktiv",
  nameRequired: "Navn er påkrævet",
  chatbotRequired: "Vælg mindst én chatbot",
  status_open: "Åben",
  status_in_review: "Under gennemgang",
  status_resolved: "Løst",
  status_dismissed: "Afvist",
  category_bug: "Bug",
  category_incorrect_answer: "Forkert svar",
  category_missing_info: "Manglende info",
  category_suggestion: "Forslag",
  category_general: "Generel",
  severity_low: "Lav",
  severity_medium: "Medium",
  severity_high: "Høj",
};
